import { render, staticRenderFns } from "./ReturnsModal.vue?vue&type=template&id=21b9700e&"
import script from "./ReturnsModal.vue?vue&type=script&lang=js&"
export * from "./ReturnsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReturnsModal.vue"
export default component.exports